import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { Numeric } from '@blade/ui-kit'
import { NetworkIcon } from '@root/entities/network/ui'
import { PRICE_PRESET } from '@root/shared/core/format'

import { CurrencyModel } from '../../model'

import type { NumericFormat } from '@blade/std-lib'
import type { NumericProps } from '@blade/ui-kit'
import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type Props = {
  currency: CurrencyModel | 'usd'
  value: BigNumber
  preset?: Array<NumericFormat.NumericFormatRule> | NumericFormat.Preset
  nativeCurrencyIconSize?: number
} & ClassNameProps &
  Pick<NumericProps, 'forceSign'>

export const CurrencyAmountCell: React.FC<Props> = ({
  className,
  currency,
  value,
  forceSign,
  preset = PRICE_PRESET,
  nativeCurrencyIconSize = 18,
  ...props
}) => {
  const renderSymbol = () => {
    if (currency === 'usd') {
      return undefined
    }
    if (CurrencyModel.isNativeOrWrapped(currency.network)(currency)) {
      return (
        <NetworkIcon size={nativeCurrencyIconSize} network={currency.network} />
      )
    }
    return <Ticker>{currency.ticker}</Ticker>
  }

  return (
    <Root {...props} className={className}>
      <StyledTypography>
        <Numeric
          value={value}
          preset={preset}
          currency={currency === 'usd' ? '$' : undefined}
          forceSign={forceSign}
        />
      </StyledTypography>
      {renderSymbol()}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  align-items: center;
  gap: 5px;
  justify-content: start;
  grid-auto-flow: column;
`

const StyledTypography = styled(Typography)``

const Ticker = styled(Typography)`
  font-size: 10px;
  font-weight: 500;
  line-height: 16px;
`
